module.exports = __webpack_public_path__ + "static/media/0_2018_07_05.2f2f65ae.jpg";